// extracted by css-extract-rspack-plugin
export default {"dialogRoot":"PasswordChangeDialog_dialogRoot__y8ZHT"};